import CopyButton from "../CopyButton";

interface Props {
  bankName: string;
  accountNumber: string;
  accountName: string;
}

const BankAccountDetails = ({
  bankName,
  accountNumber,
  accountName,
}: Props) => {
  return (
    <>
      <div className="mb-8">
        <p className="font-bold text-xs text-gray-600">BANK NAME</p>
        <p className="font-bold">{bankName}</p>
      </div>
      <div className="mb-8">
        <p className="font-bold text-xs text-gray-600">ACCOUNT NUMBER</p>
        <div className="flex gap-2">
          <p className="font-bold">{accountNumber}</p>
          <CopyButton textToCopy={accountNumber} />
        </div>
      </div>
      <div>
        <p className="font-bold text-xs text-gray-600">ACCOUNT NAME</p>
        <p className="font-bold">{accountName}</p>
      </div>
    </>
  );
};

export default BankAccountDetails;
